import clientV2 from '@/lib/request-v2'
import client from '../lib/request'

export default {
  getShopData(param = {}) {
    return client.post('admin/getShopData', param)
  },
  getCheckoutId() {
    return clientV2.get(`/shop/checkout-profile`)
  },
}
